import { useIntl } from 'react-intl';

import ParentPopover from './ParentPopover';

const axlesInfoDataUrl = new URL('./assets/axles-info.png', import.meta.url).href;

const TitleInfoPopover = () => {
    const intl = useIntl();

    return (
        <ParentPopover
            title={intl.formatMessage({ id: 'intl-msg:tyres.info.title' })}
            content={
                <div className="display-flex flex-column gap-10">
                    <p className="text-size-14 margin-0">
                        <span className="text-medium padding-right-4">
                            {intl.formatMessage({ id: 'intl-msg:tyres.info.label' })}
                        </span>
                        {intl.formatMessage({ id: 'intl-msg:tyres.info.axleDescription' })}
                    </p>
                    <img src={axlesInfoDataUrl} alt="Axles illustration" className="width-100pct" />
                    <p className="text-size-12 text-color-gray margin-0 text-italic">
                        *{intl.formatMessage({ id: 'intl-msg:tyres.info.disclaimer' })}
                    </p>
                </div>
            }
        >
            <span className="rioglyph rioglyph-info-sign margin-left-5 cursor-pointer" />
        </ParentPopover>
    );
};

export default TitleInfoPopover;
